import { Banner } from '@/model';
import {
  GetMediaBannerByIdResponse,
  GetMediaBannersItemResponse,
  GetMediaBannersResponse,
  PostMediaBannerResponse,
  PutMediaBannerResponse,
} from '@/services/response/banner';

export class BannerConverter {
  static toDomainFromPostResponse(response: PostMediaBannerResponse): Banner {
    return {
      uuid: response.uuid,
      title: response.title,
      source_url: response.source_url,
      image_url: response.image_url,
      order: response.order,
      status: response.status,
      created_at: response.created_at,
      updated_at: response.updated_at,
      partner_name: response.partner_name,
      start_at: response.start_at,
      end_at: response.end_at,
      partner_uuid: response.partner_uuid,
    };
  }

  static toDomainFromGetItemResponse(response: GetMediaBannersItemResponse): Banner {
    return {
      uuid: response.uuid,
      business_unit_uuid: response.business_unit_uuid,
      title: response.title,
      source_url: response.source_url,
      image_url: response.image_url,
      order: response.order,
      status: response.status,
      created_at: response.created_at,
      updated_at: response.updated_at,
      partner_name: response.partner_name,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      start_at: response.start_at,
      end_at: response.end_at,
      partner_uuid: response.partner_uuid,
    };
  }

  static toDomainFromPaginatedResponse(response: GetMediaBannersResponse): Banner[] {
    return response.data.map(BannerConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromByIdResponse(response: GetMediaBannerByIdResponse): Banner {
    return {
      uuid: response.uuid,
      business_unit_uuid: '', // Não está no response
      title: response.title,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
      source_url: response.source_url,
      image_url: response.image_url,
      order: response.order,
      status: response.status,
      created_at: response.created_at,
      updated_at: response.updated_at,
      partner_name: response.partner_name,
      start_at: response.start_at,
      end_at: response.end_at,
      partner_uuid: response.partner_uuid,
    };
  }

  static toDomainFromPutResponse(response: PutMediaBannerResponse): Banner {
    return {
      uuid: response.uuid,
      title: response.title,
      source_url: response.source_url,
      image_url: response.image_url,
      order: response.order,
      status: response.status,
      created_at: response.created_at,
      updated_at: response.updated_at,
      partner_name: response.partner_name,
      start_at: response.start_at,
      end_at: response.end_at,
      partner_uuid: response.partner_uuid,
    };
  }
}
